import { StatutAttestation, StatutDeclaration } from '@common/services';
import { SelectOption } from '@common/ui';
import { ETABLISSEMENT_STATUT_FICHIER_TEXTS } from './texts';

export const ETABLISSEMENT_FICHIER_STATUS_STYLES: Record<StatutDeclaration | StatutAttestation, Attributes> = {
  'NON_TELECHARGEE': {
    text: ETABLISSEMENT_STATUT_FICHIER_TEXTS['NON_TELECHARGEE'],
    borderColor: '#EA7A7A',
    textColor: '#953333',
  },
  'NON_DEPOSEE': {
    text: ETABLISSEMENT_STATUT_FICHIER_TEXTS['NON_DEPOSEE'],
    borderColor: '#EA7A7A',
    textColor: '#953333',
  },
  'PARTIELLE': {
    text: ETABLISSEMENT_STATUT_FICHIER_TEXTS['PARTIELLE'],
    borderColor: '#D6AA57',
    textColor: '#A95C01',
  },
  'DEPOSEE': {
    text: ETABLISSEMENT_STATUT_FICHIER_TEXTS['DEPOSEE'],
    borderColor: '#57D6BE',
    textColor: '#007962',
  },
};

export const DECLARATION_STATUT_OPTIONS: SelectOption[] = Object.entries(ETABLISSEMENT_FICHIER_STATUS_STYLES).reduce((options, [key, value]) => {
  options.push({ value: key, label: value.text });
  return options;
}, [] as SelectOption[]);

export const ATTESTATION_STATUT_OPTIONS: SelectOption[] = [
  { label: ETABLISSEMENT_STATUT_FICHIER_TEXTS['NON_DEPOSEE'], value: StatutAttestation.NON_DEPOSEE },
  { label: ETABLISSEMENT_STATUT_FICHIER_TEXTS['DEPOSEE'], value: StatutAttestation.DEPOSEE },
];

interface Attributes {
  text: string;
  textColor: string;
  borderColor: string;
}